module.exports = __webpack_public_path__ + "static/img/RW1264_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RW1264_1.png
// module id = rpzP
// module chunks = 0